import { Avatar, Box, Tooltip } from "@mui/material";

export default function UserAvatar({
  user,
  size = 32,
  enableTooltip = false,
  tooltipTitle = null,
  showLabel = false,
  label = null,
}) {
  const getInitials = (user) => {
    if (!user) return "";

    const { first_name = "", last_name = "" } = user;

    return `${first_name[0] || ""}${last_name[0] || ""}`.toUpperCase();
  };

  label = label
    ? label
    : user.full_name || `${user.first_name} ${user.last_name}`;
  tooltipTitle = tooltipTitle
    ? tooltipTitle
    : user.full_name || `${user.first_name} ${user.last_name}`;

  if (!user) {
    return null;
  }

  const content = (
    <Box display="flex" alignItems="center" gap={1}>
      <Avatar sx={{ width: size, height: size, fontSize: 16 }}>
        {getInitials(user)}
      </Avatar>

      {showLabel ? label : null}
    </Box>
  );

  if (enableTooltip) {
    return <Tooltip title={tooltipTitle}>{content}</Tooltip>;
  }

  return content;
}
